module.exports = __webpack_public_path__ + "static/img/r2.bede772b.png";